/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';

import { AppRoute } from '../config/route-config';
import WelcomePage from '../components/WelcomePage';
import Identity from '../components/IdentityTab';
import DOFSubmitted from '../components/Submission';
import OTPAuthentication from '../components/OTPAuthentication';
import ResidenceTab from '../components/ResidenceTab';
import IncomeTab from '../components/IncomeTab';
import { GetDropDownOptions, setDocumentState, setCustomerDetails, setExCustomerDetails, MakeFeatureFlagObjFn, fetchSecretValues } from '../common/helperFunction/HelperFunction';
import { IncomeContext } from '../context/userInformation/IncomeContextProvider';
import { IdentityContext } from '../context/userInformation/IdentityContextProvider';
import { ResidenceContext } from '../context/userInformation/ResidenceContextProvider';
import { getConfigDetails, GetDropOptions, validateAuthKey } from '../api/user';
import ScreenLoader from '../common/loader/ScreenLoader';
import { getCustomerStgDetails, GetCustomerDetails } from '../api/user';
import { DecryptDataPayload, DecryptedData } from '../interface/DecryptInterface';
import crypto, { createDecipheriv } from "crypto";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import i18n from '../i18n';

import SelfieUpload from '../components/SelfieUpload';
import LivelinessCheckFailed from '../components/LivelinessCheckFailed';

export const routesTestId = 'routesTestId';

export const Routes: React.FC = () => {

  const [language, setLanguage] = useState<string>('es');
  useEffect(() => {
    const language: any = window.sessionStorage.getItem('language')
    console.log("language", language);
    i18n.changeLanguage(language)


  }, [language])

  const { setTypeOfIncomeOptions, setJobTypeOptions, setIncomeInformation } = useContext(IncomeContext) || {};
  const incomeInfo = useContext(IncomeContext) || {};
  const { setStgCustomerEmpId } = useContext(IncomeContext) || {};
  const { setGenderDropOptions, setMaritalStatusDropOptions, setRacPromotionDropOptions, setIdentityInformation, identityInformation, setSecretValues, setLiveLinessCheckEnable } = useContext(IdentityContext) || {};
  const identityInfo = useContext(IdentityContext) || {};
  const { getCustomerRes, setGetCustomerRes, getStgCustomerRes, setGetStgCustomerRes } = useContext(IdentityContext) || {}
  const { setResidenceRadioOption, setResidenceTenureTypeOption, setStateOption, setResidenceInformation, setStateDetails } = useContext(ResidenceContext) || {};
  const residenceInfo = useContext(ResidenceContext) || {};
  const { setStgCustomerAddressId } = useContext(ResidenceContext) || {};
  const { setCountryCode, setStoreDetails, setFeatureFlagDetails, setStgCustomerProfileId, setCustomerId} = useContext(IdentityContext) || {};

  const [screenLoader, setScreenLoader] = useState(false);
  const context = useContext(IdentityContext);
  const { t } = useTranslation();


  if (!context) {
    return <div> {t("Application is not available")}</div>;
  }

  const { setLinkExpirationPopup } = context;

  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.search);
  const EncodeAuthKey = queryParams.get('AuthKey');
  const EncodedStorecode = queryParams.get('StoreCode') || '';
  const EncodeUserId = queryParams.get('userId') || '';
  const EncodeClientId = queryParams.get('clientId');
  const type = queryParams.get('type');
  const dofLanguage = queryParams.get('language') || 'ZW4=';
  const decodedLanguage = atob(dofLanguage)
  const identifier = queryParams.get('identifier');
  const idDocType = queryParams.get('idDocType');
  const productCode = queryParams.get('productCode') || '';
  const otpVerifyReq = queryParams.get('otpVerifyReq') || '';
  // agreementId is passed when the DOF link is sent from the agreement component
  // for a liveness check tied to a specific rental agreement.
  const agreementIdParam = queryParams.get('agreementId');

  let dofAuthValues: Record<string, string> = {};
  const dofAuthSessionValue: string | null = window.sessionStorage.getItem("dofAuthValues");
  const sessionStorageValues: Record<string, any> | null = JSON.parse(dofAuthSessionValue || 'null');

  useEffect(() => {
    const storedLang = sessionStorage.getItem('language');
    if (!sessionStorageValues || Object.keys(sessionStorageValues).length < 1 || EncodeAuthKey !== sessionStorageValues?.authKey) {
      if (EncodedStorecode) {
        dofAuthValues.encodeStoreNumber = EncodedStorecode;
        dofAuthValues.storeNumber = atob(EncodedStorecode);
        window.sessionStorage.setItem("storeNumber", atob(EncodedStorecode));
      }
      if (dofLanguage && (storedLang == '' || storedLang == null)) {
        window.sessionStorage.setItem('language', decodedLanguage);
        setLanguage(decodedLanguage);
      }
      if (EncodeUserId) {
        dofAuthValues.userId = EncodeUserId;
        dofAuthValues.encodeUserId = atob(EncodeUserId);
        window.sessionStorage.setItem("encodeUserId", atob(EncodeUserId));
      }
      if (EncodeAuthKey) {
        dofAuthValues.encodeAuthKey = EncodeAuthKey;
        dofAuthValues.authKey = EncodeAuthKey;
        window.sessionStorage.setItem("authKey", EncodeAuthKey);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
      if (EncodeClientId) {
        dofAuthValues.clientId = atob(EncodeClientId);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));

      }
      if (idDocType) {
        dofAuthValues.idDocType = atob(idDocType);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
      if (otpVerifyReq) {
        dofAuthValues.otpVerifyReq = otpVerifyReq;
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
      if (type) {
        dofAuthValues.type = atob(type);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
      if (identifier) {
        dofAuthValues.identifier = atob(identifier);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));

      }
      if (!sessionStorageValues) {
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify(dofAuthValues));
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));

      }
      if (productCode) {
        dofAuthValues.productCode = atob(productCode);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
      if (productCode) {
        dofAuthValues.productCode = atob(productCode);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
      // Store agreementId from URL param — used in liveness check flow to detect
      // if this DOF was sent for a specific rental agreement.
      if (agreementIdParam) {
        dofAuthValues.agreementId = atob(agreementIdParam);
        window.sessionStorage.setItem("dofAuthValues", JSON.stringify({ ...dofAuthValues }));
      }
    }
    else {
      sessionStorage.setItem('language', decodedLanguage);
      setLanguage(decodedLanguage);
      i18n.changeLanguage(decodedLanguage);
    }
    validateAuthKeyFn(
      EncodeAuthKey ?? sessionStorageValues?.authKey,
      EncodedStorecode ?? sessionStorageValues?.encodeStoreNumber
    );
  }, []);

  const fetchStgCustomerDetails = async (identifier: string, type: string, countryCode :string) => {
    setScreenLoader(true);
    const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
    console.log('isStoreCodeFlow ', isStoreCodeFlow);
    const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
    console.log('fetchStgCustomerDetails function triggered')
    await setDocumentState(identifier, residenceInfo, incomeInfo, identityInfo, undefined, type);
    const response: any = await getCustomerStgDetails(identifier, isStoreCodeFlow, accessToken);
    setStgCustomerProfileId && setStgCustomerProfileId(identifier)
    // Persist stgCustomerProfileId to sessionStorage so it survives a reload
    const currentDofAuth = JSON.parse(window.sessionStorage.getItem('dofAuthValues') || '{}');
    window.sessionStorage.setItem('dofAuthValues', JSON.stringify({ ...currentDofAuth, stgCustomerProfileId: identifier }));
    if (response.status == '200') {
      setStgCustomerAddressId && setStgCustomerAddressId(String(response?.data?.addressInfo?.stageCustomerAddressId));
      setStgCustomerEmpId && setStgCustomerEmpId(String(response?.data?.employmentInfo?.stageCustomerEmploymentId))
      if(response.data.countryCode == null || response.data.countryCode == undefined){
        response.data.countryCode = countryCode
      }
      setCustomerDetails(response.data, setIdentityInformation!, setResidenceInformation!, setIncomeInformation!);
      setGetStgCustomerRes(response?.data)
    }
    setScreenLoader(false);
  };

  const fetchExCustomerDetails = async (identifier: string, type: string, countryCode:string) => {
    setScreenLoader(true);
    if (identifier) {
      setCustomerId && setCustomerId(identifier)
      const getCustomerRequest = {
        getCustomerDetails: true,
        customerId: identifier,
      };
      const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
      const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
      const customerData: any = await GetCustomerDetails(getCustomerRequest, isStoreCodeFlow, accessToken);
      if (customerData?.status === 200 && customerData?.data) {
        const transactionId = customerData?.data?.stageCustomerProfileId;
        await setDocumentState(transactionId, residenceInfo, incomeInfo, identityInfo, identifier, type);
        const decryptDataPayload: DecryptDataPayload = {
          decryptData: {},
          encryptKey: crypto.randomBytes(16).toString("hex"),
          ivKey: crypto.randomBytes(8).toString("hex"),
        };

        if (customerData?.data?.dateOfBirthEnc)
          decryptDataPayload.decryptData.dateOfBirth =
            customerData.data.dateOfBirthEnc;
        if (customerData?.data?.taxIdEnc)
          decryptDataPayload.decryptData.taxIdEnc =
            customerData?.data?.taxIdEnc;
        if (customerData?.data?.governmentId)
          decryptDataPayload.decryptData.governmentIdEnc =
            customerData.data.governmentIdEnc;

        setGetCustomerRes(customerData?.data)

        if (customerData?.data?.stgCustomerProfileId) {
          setStgCustomerProfileId && setStgCustomerProfileId(customerData?.data?.stgCustomerProfileId)
          // Persist stgCustomerProfileId to sessionStorage so it survives a reload
          const currentDofAuth = JSON.parse(window.sessionStorage.getItem('dofAuthValues') || '{}');
          window.sessionStorage.setItem('dofAuthValues', JSON.stringify({ ...currentDofAuth, stgCustomerProfileId: customerData?.data?.stgCustomerProfileId }));
          await fetchStgCustomerDetails(customerData?.data?.stgCustomerProfileId, 'NC', countryCode);
        }

        const decryptDataResponse = await GetCustomerDetails(
          decryptDataPayload,
          isStoreCodeFlow,
          accessToken
        );
        console.log("decryptResponse", decryptDataResponse);

        const decryptedData: DecryptedData = await handleDecryption(
          decryptDataPayload,
          decryptDataResponse
        );
        console.log('decrypted data ', decryptedData, customerData.data);

        setExCustomerDetails(customerData.data, setIdentityInformation!, setResidenceInformation!, setIncomeInformation!, countryCode, decryptedData)
      }
    }
    setScreenLoader(false);
  };
  const handleDecryption = async (
    decryptDataPayload: DecryptDataPayload,
    decryptDataResponse: any
  ): Promise<DecryptedData> => {
    if (
      decryptDataResponse?.status == 200 &&
      decryptDataResponse?.data?.decryptData
    ) {
      return {
        dateOfBirth: await decryptCustomerData(
          decryptDataPayload.encryptKey,
          decryptDataPayload.ivKey,
          decryptDataResponse?.data?.decryptData?.dateOfBirth
        ),
        taxId: await decryptCustomerData(
          decryptDataPayload.encryptKey,
          decryptDataPayload.ivKey,
          decryptDataResponse?.data?.decryptData?.taxIdEnc
        ),
        governmentId: await decryptCustomerData(
          decryptDataPayload.encryptKey,
          decryptDataPayload.ivKey,
          decryptDataResponse?.data?.decryptData?.governmentIdEnc
        ),
      };
    } else {
      return {
        dateOfBirth: '',
        taxId: '',
        governmentId: '',
      };
    }
  };
  const decryptCustomerData = async (
    encryptKey: string,
    ivKey: string,
    encryptedData: any
  ) => {
    if (encryptedData) {
      return getData(encryptKey, ivKey, encryptedData);
    }
    return '';
  };
  const getData = (key: string, iv: string, data: string) => {
    const decipher = createDecipheriv("aes-256-cbc", key, iv);
    let result: any = decipher.update(data, "hex", "utf8");
    result += decipher.final("utf8");
    return result;
  };
  const validateAuthKeyFn = async (EncodeAuthKey?: string, EncodedStorecode?: string) => {
    setScreenLoader(true);

    // On reload, URL query params (type, identifier) are gone — restore from sessionStorage.
    const effectiveType: string | undefined = type ? atob(type) : sessionStorageValues?.type;
    const effectiveIdentifier: string | undefined = identifier ? atob(identifier) : sessionStorageValues?.identifier;

    // Detect reload: original URL had no AuthKey/StoreCode params — user refreshed mid-flow.
    // In this case, restore data but stay on the current route instead of pushing to /welcome.
    const isReload: boolean = !EncodeAuthKey && !EncodedStorecode;
    const currentPath: string = window.location.pathname;

    const storedStgProfileId: string | undefined = sessionStorageValues?.stgCustomerProfileId;
    const hasStoredProfile: boolean = !!storedStgProfileId;
    const isSelfieFlow: boolean = sessionStorageValues?.idDocType === 'SELF';

    if (EncodeAuthKey) {
      let ResponseValidateAuth: any = await validateAuthKey(EncodeAuthKey, false);
      ResponseValidateAuth = ResponseValidateAuth?.data;
      if (ResponseValidateAuth?.data?.valid) {
        setSecretValues && await fetchSecretValues(setSecretValues)
        const countryCode = await getfeatures();
        if (hasStoredProfile) {
          await fetchStgCustomerDetails(storedStgProfileId!, 'NC', (countryCode as string));
        } else {
          if (effectiveType && effectiveIdentifier && effectiveType == 'EC') {
            console.log("EC");
            await fetchExCustomerDetails(effectiveIdentifier, 'EC', (countryCode as string));
          }
          if (effectiveType && effectiveIdentifier && effectiveType == 'NC') {
            console.log('NC');
            await fetchStgCustomerDetails(effectiveIdentifier, 'NC', (countryCode as string));
          }
        }
        setLinkExpirationPopup(false);
        if (hasStoredProfile && isSelfieFlow) {
          setLiveLinessCheckEnable && setLiveLinessCheckEnable(true);
          history.push('/identity');
        } else {
          history.push('/welcome');
        }
      }
      else {
        setLinkExpirationPopup(true)
        setScreenLoader(false);
        history.push('/welcome');
      }
    } else if (EncodedStorecode) {
      console.log("EncodedStorecodeEncodedStorecode", EncodedStorecode)
      const DecodeStoreCode = atob(EncodedStorecode);
      console.log('DecodeStoreCode sore', DecodeStoreCode)

      const ValidateStore = await validateAuthKey(DecodeStoreCode, true);
      if (ValidateStore) {
        setSecretValues && await fetchSecretValues(setSecretValues)
        const countryCode = await getfeatures();
        if (hasStoredProfile) {
          await fetchStgCustomerDetails(storedStgProfileId!, 'NC', (countryCode as string));
        } else {
          if (effectiveType && effectiveIdentifier && effectiveType == 'EC') {
            console.log("EC");
            await fetchExCustomerDetails(effectiveIdentifier, 'EC', (countryCode as string));
          }
          if (effectiveType && effectiveIdentifier && effectiveType == 'NC') {
            console.log('NC');
            await fetchStgCustomerDetails(effectiveIdentifier, 'NC', (countryCode as string));
          }
        }
        setLinkExpirationPopup(false);
        if (hasStoredProfile && isSelfieFlow) {
          setLiveLinessCheckEnable && setLiveLinessCheckEnable(true);
          history.push('/identity');
        } else {
          history.push('/welcome');
        }
      }
      else {
        setLinkExpirationPopup(true)
        setScreenLoader(false);
        history.push('/welcome');
      }
    }
    else {
      // No URL params — this is a mid-flow reload. Restore data and stay on current route.
      console.log('Reload detected at:', currentPath);
      const storedProfileId: string | undefined = sessionStorageValues?.stgCustomerProfileId;
      if (storedProfileId) {
        setStgCustomerProfileId && setStgCustomerProfileId(storedProfileId);
      }
      setSecretValues && await fetchSecretValues(setSecretValues);
      const countryCode = await getfeatures();
      if (storedProfileId) {
        await fetchStgCustomerDetails(storedProfileId, 'NC', (countryCode as string));
      }
      if (effectiveType && effectiveIdentifier && effectiveType == 'EC') {
        await fetchExCustomerDetails(effectiveIdentifier, 'EC', (countryCode as string));
      }
      if (!storedProfileId && effectiveType && effectiveIdentifier && effectiveType == 'NC') {
        await fetchStgCustomerDetails(effectiveIdentifier, 'NC', (countryCode as string));
      }
      setLinkExpirationPopup(false);
    }

    setScreenLoader(false);
  };

  useEffect(() => {
    const onAppLoad = async () => {
      try {
        setScreenLoader(true);
        await GetDropDownOptions(
          setTypeOfIncomeOptions!, setJobTypeOptions!,
          setGenderDropOptions!, setMaritalStatusDropOptions!,
          setRacPromotionDropOptions!,
          setResidenceRadioOption!, setResidenceTenureTypeOption!, setStateOption!, setStateDetails!
        );
        setScreenLoader(false);
      } catch (error) {
        console.error('Error fetching dropdown options:', error);
      }
    };

    onAppLoad();
  }, []);

  const getfeatures = async () => {
    try {
      setScreenLoader(true);
      let dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues")
      let sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
      const StoreNumber = sessionStorageValues?.storeNumber
      const featureFlagReq = {
        storeNumbers: [StoreNumber],
        paramKeyNames: ['CountryCode', 'EnableIdValidation', 'EnableLivelinessCheck', 'MXStoreIdentifier', 'EnableManualIDUpload', 'NAATValidationNoOfTrials','MXCallCenterDL','MXOtpValidation','DateTimeLocalization'],
      };
      const FeatureFlagResponse = await getConfigDetails(
        featureFlagReq, sessionStorageValues?.authKey ? false : sessionStorageValues?.storeNumber,
        sessionStorageValues?.authKey ? sessionStorageValues?.authKey : sessionStorageValues?.storeNumber
      );
      let countryCode = '';

      if (FeatureFlagResponse?.status == 200) {
        const configDetail = FeatureFlagResponse?.data?.storeProfileResponse?.configDetails[0]?.configDetails;
        const featureFlagDetails = JSON.stringify(configDetail)
        window.sessionStorage.setItem('featureFlagDetails', featureFlagDetails);
        if (configDetail) {
          const FeatureFlagObj = MakeFeatureFlagObjFn(
            FeatureFlagResponse?.data?.storeProfileResponse?.configDetails[0]?.configDetails
          );
          console.log('FeatureFlagObj', FeatureFlagObj);
          setFeatureFlagDetails && setFeatureFlagDetails(FeatureFlagObj);
          if (FeatureFlagObj?.CountryCode == 1) {
            countryCode = await getCountryCodeAndStoreDetails(StoreNumber);
          }

        }
      }
      setScreenLoader(false);
      return countryCode;


    } catch (error) {
      setScreenLoader(false);
      console.error('Error fetching feature flags:', error);
    }
  };

  const getCountryCodeAndStoreDetails = async (storeNumber: string) => {
    try {
      const dropOpts = {
        references: ['country_code'],
        status: "Y"
      }
      const configOpt = {
        storeNumbers: [storeNumber],
        paramKeyNames: ['CountryCode'],
        getStoreDetails: true
      }
      setScreenLoader(true);
      const response = await Promise.all([GetDropOptions(dropOpts, true, storeNumber), getConfigDetails(configOpt, true, storeNumber)]);
      setScreenLoader(false);
      console.log('Country Code details', response[0].data.referenceDetails);
      console.log('store details', response[1].data.response);
      if (response && response[1].data.response.length > 0 && response[0].data.referenceDetails.length > 0) {
        setStoreDetails && setStoreDetails(response[1].data.response[0]);
        if (response[0].data.referenceDetails.length > 0) {
          setCountryCode && setCountryCode(response[0].data.referenceDetails);
          const countryAbb = response[1].data.response[0]?.countryAbb?.toUpperCase();
          const regionCode = response[0].data.referenceDetails.filter((item: any) => item.abbreviation == countryAbb);
          console.log("regionCoderegionCode", regionCode)
          console.log("countryAbbcountryAbb", countryAbb)
          setIdentityInformation && setIdentityInformation((prev) => ({
            ...prev,
            countryCode: regionCode.length > 0 ? regionCode[0].countryCodeValue : ''
          }));
          return regionCode.length > 0 ? regionCode[0].countryCodeValue : '';
        }
      }
    } catch (e) {
      setScreenLoader(false);
      console.error('Error fetching country code and store details:', e);
    }

  }

  return (
    <>
      {screenLoader && <ScreenLoader />}
      <div data-testid={routesTestId}>
        <Switch>

          <Route exact path={AppRoute.WelcomePage} component={WelcomePage} />
          <Route exact path={AppRoute.IdentityTab} component={Identity} />
          <Route exact path={AppRoute.Submisson} component={DOFSubmitted} />
          <Route exact path={AppRoute.OTPAuthentication} component={OTPAuthentication} />
          <Route exact path={AppRoute.ResidenceTab} component={ResidenceTab} />
          <Route exact path={AppRoute.IncomeTab} component={IncomeTab} />
          <Route exact path={AppRoute.SelfieUpload} component={SelfieUpload} />
          <Route exact path={AppRoute.LivelinessCheckFailed} component={LivelinessCheckFailed} />

        </Switch>
      </div>
    </>
  );
};
